import XCircleIcon from "assets/icon/XCircleIcon";

export default function AccessDenied(){
    return(
        <div className="h-full w-full flex flex-col gap-6 items-center justify-center">
            <div>
                <XCircleIcon className="w-24 fill-red-800" />
            </div>
            <div className="flex flex-col items-center">
                <span className="font-semibold text-3xl ">Access Denied</span>
                <span>You don't have access to this page</span>
                <span>Please contact your administrator for permission and access</span>
            </div>
        </div>
    )
}